import React from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import Typography from '@material-ui/core/Typography';

import CloseIcon from '@material-ui/icons/Close';
import HistoryIcon from '@material-ui/icons/History';

import EvolucaoDialog from '../commons/EvolucaoDialog';
import MajoritarioChart from './MajoritarioChart';
import MajoritarioPopper from './MajoritarioPopper';
import Mapa from './Mapa';
import ProporcionalChart from './ProporcionalChart';
import SelectField from '../commons/SelectField';

import { get, jsonParser } from '../../utils/Client';
import AuthenticationStore from '../../stores/AuthenticationStore';
import EvolucaoStore from '../../stores/EvolucaoStore';
import MapaStore from '../../stores/MapaStore';
import Stores from '../../stores/Stores';
import UIStore from '../../stores/UIStore';

const candidatoStore = Stores.load('candidato');

class MapaRegiao extends React.Component {
  state = {
    mapa: { features: [] },
    selected: null,
    anchorEl: null,
    hoverPath: null,
    hoverIndex: -1,
  };

  componentWillMount() {
    let { tipo } = this.props.match.params;
    this.config(tipo);
  }

  componentWillReceiveProps(nextProps) {
    let { tipo } = nextProps.match.params;
    this.config(tipo);
  }

  config(tipo) {
    let title = 'Base ';
    if (tipo === 'municipios') {
      title += 'Municípios';
    } else if (tipo === 'microregioes') {
      title += 'Micro-Regiões';
    } else if (tipo === 'mesoregioes') {
      title += 'Meso-Regiões';
    }
    UIStore.init(title, null, null, false, () => {
      if (this.state.selected) {
        MapaStore.loadIntencoes(tipo, this.state.selected.properties.codigo);
      }
      if (!AuthenticationStore.me.cargo.proporcional) {
        MapaStore.loadVencedores(tipo).then(() => this.forceUpdate());
      } else if (MapaStore.candidato) {
        MapaStore.loadPresenca(tipo).then(() => this.forceUpdate());
      }
    });
    this.loadMap(tipo);
    candidatoStore.size = 9000;
    candidatoStore.query();
    if (!AuthenticationStore.me.cargo.proporcional) {
      MapaStore.loadVencedores(tipo).then(() => this.forceUpdate());
    } else if (MapaStore.candidato) {
      MapaStore.loadPresenca(tipo).then(() => this.forceUpdate());
    }
  }

  fill(index) {
    if (
      !AuthenticationStore.me.cargo.proporcional &&
      MapaStore.vencedores.length > index
    ) {
      let vencedor = MapaStore.vencedores[index];
      let candidatos = candidatoStore.list.filter(
        c => c.id === vencedor.candidatoId
      );
      if (candidatos.length > 0) return candidatos[0].partido.cor;
    }
    if (
      MapaStore.candidato &&
      MapaStore.presenca.length > index &&
      MapaStore.presenca[index] &&
      MapaStore.presenca[index].media
    ) {
      return MapaStore.candidato.partido.cor;
    }
    return '#ccc';
  }

  loadMap = tipo =>
    get(`/${tipo}/byuf/${AuthenticationStore.me.pesquisa.uf}`)
      .then(jsonParser)
      .then(mapa => this.setState({ mapa }));

  select(d) {
    if (d !== null && d !== this.state.selected) {
      this.setState({ selected: d });
      MapaStore.loadIntencoes(
        this.props.match.params.tipo,
        d.properties.codigo
      );
    } else {
      this.setState({ selected: null });
      MapaStore.intencoes = [];
    }
  }

  getPopper() {
    let { hoverPath, anchorEl, hoverIndex } = this.state;
    if (
      hoverIndex >= 0 &&
      !AuthenticationStore.me.cargo.proporcional &&
      MapaStore.vencedores.length > hoverIndex
    ) {
      let vencedor = MapaStore.vencedores[hoverIndex];
      let candidatos = candidatoStore.list.filter(
        c => c.id === vencedor.candidatoId
      );
      return (
        <MajoritarioPopper
          anchorEl={anchorEl}
          path={hoverPath}
          open={hoverIndex >= 0}
          candidato={candidatos[0]}
          media={vencedor.media}
        />
      );
    }
    return (
      <Popper anchorEl={anchorEl} open={hoverIndex > 0} placement="right">
        <Paper>
          <Typography variant="headline">
            {hoverPath ? hoverPath.properties.nome : ''}
          </Typography>
        </Paper>
      </Popper>
    );
  }

  render() {
    let { tipo } = this.props.match.params;
    let { selected, mapa } = this.state;
    let municipio = 'Geral';
    if (selected) {
      municipio = selected.properties.nome;
    }
    return (
      <React.Fragment>
        <div style={{ position: 'absolute', right: '20px', top: '20px' }}>
          <Paper style={{ width: '500px' }}>
            <Typography
              variant="headline"
              style={{
                padding: '16px',
                display: 'flex',
                justifyContent: 'space-between',
                AlignItems: 'center',
              }}
            >
              {municipio}
              {selected ? (
                <div>
                  <IconButton
                    onClick={() =>
                      EvolucaoStore.loadIntencoes(
                        tipo,
                        selected.properties.codigo
                      )
                    }
                  >
                    <HistoryIcon />
                  </IconButton>
                  <IconButton onClick={() => this.select(null)}>
                    <CloseIcon />
                  </IconButton>
                </div>
              ) : (
                ''
              )}
            </Typography>
            {AuthenticationStore.me.cargo.proporcional ? (
              <React.Fragment>
                <SelectField
                  item={MapaStore}
                  field="candidato"
                  list={candidatoStore.list}
                  labelFunc={c => (
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        paddingRight: '16px',
                      }}
                    >
                      <span>
                        {c.nome} ({c.numero})
                      </span>
                      <Chip
                        key={c.id}
                        label={c.partido.sigla}
                        style={{
                          fontWeight: 'bold',
                          backgroundColor: c.partido.cor,
                          color: 'white',
                        }}
                      />
                    </div>
                  )}
                  style={{ margin: '16px', width: 'calc(100% - 32px)' }}
                  onChange={() => {
                    if (MapaStore.candidato) {
                      MapaStore.loadPresenca(tipo).then(() =>
                        this.forceUpdate()
                      );
                    }
                  }}
                />
                <ProporcionalChart
                  selected={MapaStore.candidato}
                  candidatos={MapaStore.intencoes}
                  onSelect={c => {
                    if (c.candidato) {
                      MapaStore.candidato = c.candidato;
                      MapaStore.loadPresenca(tipo).then(() =>
                        this.forceUpdate()
                      );
                    }
                  }}
                />
              </React.Fragment>
            ) : (
              <MajoritarioChart candidatos={MapaStore.intencoes} />
            )}
          </Paper>
        </div>

        <Mapa
          shape={mapa}
          selected={selected}
          keyProperty="codigo"
          fill={(d, i) => this.fill(i)}
          strokeWidth={(d, i) => (d === selected ? 2 : 1)}
          onSelect={d => this.select(d)}
          onMouseEnter={(d, i, e) =>
            this.setState({
              anchorEl: e.currentTarget,
              hoverIndex: i,
              hoverPath: d,
            })
          }
          onMouseOut={() => this.setState({ hoverIndex: -1 })}
        />
        <EvolucaoDialog
          title="Intenções da Região"
          opened={EvolucaoStore.intencoes != null}
          data={EvolucaoStore.intencoes}
          onOK={() => (EvolucaoStore.intencoes = null)}
          columnFunc={col =>
            col === 'NAO_VOTARA'
              ? 'Não Votarão'
              : col === 'INDECISO'
                ? 'Indecisos'
                : col === 'BRANCO'
                  ? 'Brancos'
                  : col === 'NULO'
                    ? 'Nulos'
                    : col
          }
        />
        {this.getPopper()}
      </React.Fragment>
    );
  }
}

export default withRouter(observer(MapaRegiao));



// WEBPACK FOOTER //
// ./src/components/mapas/index.js